import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { IconLock, IconAlert, IconLoader } from "../components/Icons";

export default function ChangePassword() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setSuccess(false);
    if (newPassword !== newPassword2) {
      setErr(t("auth.passwordsMismatch"));
      return;
    }
    if (newPassword.length < 8) {
      setErr(t("auth.passwordTooShort"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: currentPassword, new_password: newPassword });
      setSuccess(true);
      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");
      setTimeout(() => nav("/"), 1500);
    } catch (e: any) {
      const msg = e?.response?.data?.detail || t("auth.changeError");
      setErr(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1>{t("auth.changeTitle")}</h1>
        <p>{t("auth.changeSubtitle")}</p>
      </div>

      <div className="card" style={{ maxWidth: 480, padding: 32 }}>
        {success && (
          <div style={{ padding: "12px 16px", marginBottom: 20, background: "var(--green-dim)", color: "var(--green)", borderRadius: "var(--radius-sm)", fontSize: 14 }}>
            {t("auth.changeSuccess")}
          </div>
        )}
        {err && (
          <div style={{ padding: "12px 16px", marginBottom: 20, background: "var(--red-dim)", color: "var(--red)", borderRadius: "var(--radius-sm)", display: "flex", alignItems: "center", gap: 8, fontSize: 14 }}>
            <IconAlert size={16} /> {err}
          </div>
        )}
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label>{t("auth.currentPassword")}</label>
            <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
          </div>
          <div>
            <label>{t("auth.newPasswordMin")}</label>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={8} />
          </div>
          <div>
            <label>{t("auth.newPassword2")}</label>
            <input type="password" value={newPassword2} onChange={(e) => setNewPassword2(e.target.value)} required minLength={8} />
          </div>
          <button type="submit" className="primary" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? <IconLoader size={18} className="muted" /> : <IconLock size={18} />} {t("auth.changePassword")}
          </button>
        </form>
      </div>
    </div>
  );
}
